


























































































































































































































import { Component, Vue,Prop, Model, Watch  } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import Pop from './components/pop.vue'
import PopNew from './components/popNew.vue';
import EmbeddedPopup from './components/embeddedPopup.vue'
import EmbeddedPopupNew from './components/embeddedPopupNew.vue'
import Text from './components/text.vue'
import {FormWheelOfFortuneSettingsVO, FormWheelSliceVO, PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import { getCountryPhoneCodeCodeList, getQueryVariable } from "@/services/api";
import EventBus from '@/utils/eventBus';
import { DISABLE_CUSTOM_STEP_TPLID, isEnableCustomStep, isEnablePrivacySetting } from "@/utils/experiment";
import { copyMiddleToStart, copyStartToMiddle } from "@/utils/copyPageConfig";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    "pop-exhibition": Pop,
    "pop-new": PopNew,
    "text-exhibition": Text,
    "embedded-popup": EmbeddedPopup,
    "embedded-popup-new": EmbeddedPopupNew,
  }
})
export default class wheelOfFortunePop extends Vue {

  @Prop(Array)
  pageSettings!:any

  @Prop(Number)
  triggerEventType!:any

  @Prop(String)
  activePageSetting!:string;

  @Prop(Object)
  formData!:TFormSaveDetailRequest<PopSettingsVO>;

  device = 'desktop'
  countryList = []
  subscribeStatus = 'success'
  /** 分步骤步数 */
  step = '1';

  showDeleteDialog = false;
  showDeletePageDialog = false;
  deletePageValue: string | null = null;

  get canAddCover() {
    const hasCover = (this.pageSettings || []).some((item: any) => item.value === 'cover');
    console.log('canAddCover', hasCover, this.formData, this.formData.coverDisplay, this.formData.popWindowWheel);
    return (
      (this.formData.popWindowWheel !== 1 && this.formData.coverDisplay === 1) &&
      !hasCover
    );
  }

  get canAddForm() {
    const formList = (this.pageSettings || []).filter((item: any) => ['start', 'middle'].includes(item.value));
    console.log('canAddForm', formList);
    const buttonAction = this.formData.settings.rules.buttonAction;
    return formList.length < 2 && buttonAction === 'open';
  }

  get enableSubscribeDifferentPage() {
    return this.formData.successPageType === 1;
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting();
  }

  get enableCustomStep() {
    if (!isEnableCustomStep() || [3, 5, 6].includes(this.triggerEventType as number)) {
      return false;
    }
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return !DISABLE_CUSTOM_STEP_TPLID.includes(templateId);
  }

  async created(): Promise<void> {
    this.getPhoneCodeCodeList()
    
    // 监听清空订阅状态的事件
    EventBus.$on('clear-subscribe-status', () => {
      this.subscribeStatus = 'success';
    });
  }

  async getPhoneCodeCodeList(){
    let {data ,status }  = await getCountryPhoneCodeCodeList({},true)
    if (status == 200) {
      this.countryList = data.data
    }
  }

  changeActivePageSetting(val: string, opacity: number){
    if (opacity != 1) {
      return;
    }
    if (val === 'start_1') {
      this.$emit('changeActivePageSetting', 'start_1');
      this.step = 2;
    } else {
      this.$emit('changeActivePageSetting', val);
    }
  }

  changeText(e:any){
    this.$emit('changeformData',e)
  }

  nextStep(){
    this.$emit('nextStep')
  }

  backStep() {
    this.$emit('backStep')
  }

  cancel(){
    this.$emit('cancel')
  }

  changeSubscribeStatus() {
    // 订阅状态切换时的处理逻辑
    // subscribeStatus 值会自动更新，通过 prop 传递给 embedded-popup
  }

  @Watch('formData.settings.rules.terminalType')
  terminalTypeChange(val:string){
    if (this.formData.settings.rules.terminalType === 'mobile') {
      this.device = 'phone'
    }else if (this.formData.settings.rules.terminalType === 'pc') {
      this.device = 'desktop'
    }else{
      this.device = 'desktop'
    }
  }

  /** 删除指定页面 */
  handleDeletePage(value: string) {
    this.deletePageValue = value;
    this.showDeletePageDialog = true;
  }

  /** 确认删除页面 */
  confirmDeletePage() {
    if (!this.deletePageValue || !this.pageSettings || !Array.isArray(this.pageSettings)) {
      this.showDeletePageDialog = false;
      return;
    }

    if (this.deletePageValue === 'cover') {
      this.pageSettings.splice(0, 1);
      delete this.formData.settings.cover;
      this.$emit('changeActivePageSetting', this.pageSettings[0].value);
      this.showDeletePageDialog = false;
      this.deletePageValue = null;
      return;
    }

    const index = this.pageSettings.findIndex((item: any) => item.value === this.deletePageValue);
    if (index > -1) {
      console.log('confirmDeletePage', this.deletePageValue,  this.activePageSetting, this.pageSettings, this.pageSettings[index]);
      // 如果是开始页，则需要将中间页的值赋值到开始页
      if (this.deletePageValue === 'start') {
        this.pageSettings[index + 1].value = 'start';
        this.pageSettings[index + 1].label = '表单';
        this.pageSettings[index + 1].deletable = false;

        // 复制中间页配置middle前缀的配置到开始页
        if (this.formData && this.formData.settings) {
          copyMiddleToStart(this.formData.settings);
          delete this.formData.settings.middle;
        }
        // 同步结束倒计时状态
        if (this.formData.settings.rules.countDownShow === false) {
          Vue.set(this.formData.settings.rules, 'endCountDownShow', this.formData.settings.rules.countDownShow);
        }
      } else if (this.deletePageValue === 'middle') {
        this.pageSettings[index - 1].label = '表单';
        this.pageSettings[index - 1].deletable = false;

        // 删除中间页的配置
        if (this.formData && this.formData.settings) {
          delete this.formData.settings.middle;
        }
      }

      // 如果要删除的是当前激活的页面，需要切换到其他页面
      if (this.activePageSetting === this.deletePageValue) {
        // 如果删除的是第一个，切换到下一个；否则切换到前一个
        if (index === 0 && this.pageSettings.length > 1) {
          this.$emit('changeActivePageSetting', this.pageSettings[1].value);
        } else if (index > 0) {
          this.$emit('changeActivePageSetting', this.pageSettings[index - 1].value);
        }
      } else if (this.deletePageValue === 'start' && this.activePageSetting === 'middle') {
        this.$emit('changeActivePageSetting', this.pageSettings[index + 1].value);
      }

      this.pageSettings.splice(index, 1);
    }

    this.showDeletePageDialog = false;
    this.deletePageValue = null;
  }

  /** 增加表单页面 */
  handleAddForm() {
    if (!this.pageSettings || !Array.isArray(this.pageSettings)) return;

    // 找到 value='start' 的位置
    let insertIndex = this.pageSettings.findIndex((item: any) => item.value === 'start');

    // 如果包含 start 页面，更新其 label 和 deletable 属性
    if (insertIndex > -1) {
      const startPage = this.pageSettings[insertIndex];
      startPage.label = '表单步骤一';
      startPage.deletable = true;
    }

    // 如果没有找到 start，则查找 cover 的位置
    if (insertIndex === -1) {
      const coverIndex = this.pageSettings.findIndex((item: any) => item.value === 'cover');
      if (coverIndex === -1) {
        // 如果既没有 start 也没有 cover，则插入到数组开头
        insertIndex = -1;
      } else {
        insertIndex = coverIndex;
      }
    }

    // 开始按钮行为打开下一步骤
    this.formData.settings.rules.buttonAction = 'open';
    this.formData.settings.rules.openUrl = '';

    // 复制开始页的配置到中间步骤页
    if (this.formData && this.formData.settings) {
      copyStartToMiddle(this.formData.settings);
    }

    // 创建新表单对象
    const newFormValue = 'middle';
    const newFormPage = {
      value: newFormValue,
      label: '表单步骤二',
      deletable: true,
      opacity: 1
    };

    // 插入新表单：如果有找到位置，则在后面插入；否则插入到数组开头
    if (insertIndex === -1) {
      this.pageSettings.unshift(newFormPage);
    } else {
      this.pageSettings.splice(insertIndex + 1, 0, newFormPage);
    }

    window?.gtagClick('modal_edit_addStepForm', '弹窗_编辑订阅工具_添加步骤_表单');
    // 切换到新表单页面
    this.$emit('changeActivePageSetting', newFormValue);
  }

  /** 增加封面页面 */
  handleAddCover() {
    if (!this.pageSettings || !Array.isArray(this.pageSettings)) return;

    // 检查是否已存在封面
    const hasCover = this.pageSettings.some((item: any) => item.value === 'cover');
    if (hasCover) {
      return;
    }

    // 创建封面对象
    const coverPage = {
      value: 'cover',
      label: '封面',
      deletable: true,
      opacity: 1,
      ...(this.enableCustomStep ? { deletable: true } : {})
    };

    // 将封面插入到数组最前面
    this.pageSettings.unshift(coverPage);

    // 使用表单的背景颜色和关闭按钮颜色
    this.formData.settings.cover = {
      coverJumpType: 'click',
      bgCoverImgUrl: undefined,
      closeColor: this.formData.settings.rules.closeColor as string,
    };

    this.formData.settings.styles.styleMap['cartx-b-show__cover'].background = this.formData.settings.styles.styleMap['cartx-b-show'].background as string;

    // 强制更新以触发计算属性重新计算
    // this.$forceUpdate();

    // 切换到封面页面
    this.$emit('changeActivePageSetting', 'cover');
  }
}
